import React, { useEffect } from "react";
import Marquee from "react-fast-marquee";
import { Link } from "react-router-dom";
import { useLanguage } from "../../context/LanguageContext";
import aboutBg from "../../images/bg/about-bg.png";

// Animated GIFs
import gif1 from "../../images/icon/original-66948a0d81d.gif";
import gif2 from "../../images/icon/0deec720000b2066289b.gif";
import gif3 from "../../images/icon/b10c3e43e836d32554bf.gif";

// About images (3 images)
import img01 from "../../images/about/img01.jpg";
import img02 from "../../images/about/img02.jpg";
import img03 from "../../images/about/img03.jpg";
import img04 from "../../images/about/img03a.jpg";
import img05 from "../../images/about/img03b.jpg";
import img06 from "../../images/about/img03c.jpg";

const AboutSection: React.FC = () => {
  const { t } = useLanguage();

  useEffect(() => {
    const bgEl = document.querySelector<HTMLElement>(".xb-about-img-wrap");
    if (bgEl) bgEl.style.backgroundImage = `url(${aboutBg})`;
  }, []);

  // Repeat the 3 images for a continuous seamless marquee loop
  const aboutImages = [img01, img02, img03, img04, img05, img06];

  return (
    <section className="about pt-140">
      <div className="container">
        <div className="sec-title about-sec-title mb-75">
          <span className="sub-title">{t.about.sectionSub}</span>
          <h2 className="title">
            {t.about.headline1}
            <span>
              <img src={gif1} alt="animation" />
            </span>{" "}
            {t.about.headline2}
            <span>
              <img src={gif2} alt="animation" />
            </span>{" "}
            {t.about.headline3}{" "}
            <span>
              <img src={gif3} alt="animation" />
            </span>
          </h2>
        </div>
      </div>

      {/* Marquee with uniform 3 images (Max height 400px & object-fit cover) */}
      <div className="xb-about-img-wrap bg_img wow">
        <Marquee speed={35} gradient={false} pauseOnHover={true}>
          {aboutImages.map((img, idx) => (
            <div key={idx} className="xb-about-img-item img-hove-effect">
              <div className="xb-img">
                <Link to="/about">
                  <img
                    src={img}
                    alt={`PT Prima Cipta Artifisial Showcase ${idx + 1}`}
                    loading="lazy"
                  />
                </Link>
              </div>
            </div>
          ))}
        </Marquee>
      </div>
    </section>
  );
};

export default AboutSection;
